export enum KeyNames {
    ENTER = 'Enter',
    ARROW_UP = 'ArrowUp',
    ARROW_DOWN = 'ArrowDown',
    CONTROL = 'control',
    ARROW_LEFT = 'ArrowLeft',
    ARROW_RIGHT = 'ArrowRight',
}
